const ordenesDeServicioRoutes = [
  {
    path: "/ordenes",
    name: "ordenes",
    component: () => import(/* webpackChunkName: "ordenes-de-servicio-page" */ "@/modules/ordenes-de-servicio/pages/OrdenesDeServicioPage.vue"),
  },
  {
    path: "/ordenes/:idOrden/registros",
    name: "ordenes.registros",
    component: () => import(/* webpackChunkName: "ordenes.registros" */ "@/views/ordenes/registros.vue"),
  },
];

export default ordenesDeServicioRoutes;
